<template>
  <div class="wrap">
    <loading-full v-if="isLoading"></loading-full>
    <header-comp></header-comp>
    <gnb-comp></gnb-comp>
    <div class="scroll_cont">
      <div class="content">
        <router-view :key="$route.fullPath"></router-view>
      </div>
      <footer-comp></footer-comp>
      <base-button class="top" @click="scrollTop" v-if="isShow"><span>탑 버튼</span></base-button>
    </div>
  </div>
  <metainfo/>
</template>

<script>
import { i18nextPromise } from '@/i18n.js'
import i18next from 'i18next'
import HeaderComp from '@/components/include/HeaderComp.vue'
import LoadingFull from '@/components/include/LoadingFull.vue'
import GnbComp from '@/components/include/GnbComp.vue'
import FooterComp from '@/components/include/FooterComp.vue'
import BaseButton from '@/components/item/BaseButton.vue'
import { useMeta } from 'vue-meta'
import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
  name: 'App',
  components: {
    HeaderComp,
    GnbComp,
    FooterComp,
    BaseButton,
    LoadingFull
  },
  data () {
    return {
      isShow: false,
      isLoading: false
    }
  },
  async setup () {
    await i18nextPromise
    return {}
  },
  computed: {
    ...mapGetters([
      'getLang',
      'getUserIp'
    ])
  },
  created () {
    this.isLoading = true
    const fetchApi = async () => {
      return await axios.get('https://get.geojs.io/v1/ip/geo.js')
    }
    const callApi = async () => {
      const res = await fetchApi()
      this.$store.dispatch('getIp', res)
      await this.delay(1000)
    }
    callApi()
    if (localStorage.getItem('lang') !== '') {
      const lang = localStorage.getItem('lang') ?? this.getUserIp
      i18next.changeLanguage(lang)
    }
  },
  mounted () {
    window.addEventListener('scroll', this.isTopButtonShow)
    useMeta( // meta값 생성
      {
        title: i18next.t('meta.title'),
        titleTemplate: `%s${i18next.t('meta.title-template')}`,
        htmlAttrs: {
          lang: localStorage.getItem('i18nextLng')
        },
        meta: [
          {
            name: 'robots',
            content: 'index,follow'
          },
          {
            vmid: 'description',
            content: i18next.t('meta.main-description')
          },
          {
            hid: 'keywords',
            name: 'keywords',
            vmid: 'keywords',
            content: i18next.t('meta.main-keywords')
          }
        ]
      }
    )
  },
  beforeUnmount () {
    window.removeEventListener('scroll', this.isTopButtonShow)
  },
  methods: {
    delay (ms) {
      return new Promise(resolve => setTimeout((resolve) => {
        this.isLoading = false
      }, ms))
    },
    scrollTop () {
      window.scroll({
        top: 0, behavior: 'smooth'
      })
    },
    isTopButtonShow () {
      this.isShow = window.scrollY > 50
    },
    checkLang () {
      this.$i18next.changeLanguage(this.getLang)
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap {
  position: relative;
}
.scroll_cont {
  position: relative;
  width: 100%; height: 100%;
  float: left;
  padding: 73px 0 0 315px;
  box-sizing: border-box;
  .btn.top {
    position: fixed;
    bottom: 60px;
    right: 65px;
    z-index: 5;
  }
}
.content {
  width: 86.7%;
  margin: 60px auto 0;
  @media (max-width: 1280px) {
    width: 894px;
  }
}
</style>
